import { render, staticRenderFns } from "./EchartBar.vue?vue&type=template&id=6624a504"
import script from "./EchartBar.vue?vue&type=script&lang=js"
export * from "./EchartBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports